<ws-button
  [mat-menu-trigger-for]="disabled ? null : selectorMenu"
  [tooltip]="tooltip"
  [disabled]="disabled"
  (click)="onMenuOpened()"
>
  <div [ngClass]="{'center': align === 'center', 'space-between': align === 'justify'}" class="flex">
    <span>
      <ng-container *ngIf="triggerTemplate; else defaultTrigger">
        <ng-container
          *ngTemplateOutlet="triggerTemplate; context: { $implicit: selected, placeholder: placeholder }"
        ></ng-container>
      </ng-container>
      <ng-template #defaultTrigger>
        {{ fixedText? fixedText : (multiSelect 
            ? (_selectedItems.length ? _selectedItems.map(formatter).join(', ') : (placeholder | translate)) 
            : (selected ? formatter(selected) : (placeholder | translate)) )
        }}
      </ng-template>
    </span>
    <span>
      <mat-icon [class.closed]="!menuOpen" [class.open]="menuOpen">
        keyboard_arrow_down
      </mat-icon>
    </span>
  </div>
</ws-button>

<mat-menu #selectorMenu class="selector-menu" [classList]="panelClass" (closed)="onMenuClosed()" (keydown)="onKeydown($event)">
  
  <!-- Calendar picker for date selection -->
  <div *ngIf="useCalendar" class="calendar-container" (click)="$event.stopPropagation()">
    <mat-calendar 
      [selected]="selectedDate" 
      (selectedChange)="onDateChange($event)"
      [maxDate]="null"
      [minDate]="null">
    </mat-calendar>
  </div>

  <!-- Regular options dropdown -->
  <ng-container *ngIf="!useCalendar">
    <ng-container *ngIf="options && options.length; else noOptions">
      <button
        *ngFor="let option of options; let i = index"
        mat-menu-item
        [ngClass]="optionItemClass"
        (click)="selectOption(option, $event)"
        [class.selected]="isSelected(option)"
        [class.highlighted]="i === highlightedIndex"
        role="option"
        [attr.aria-selected]="isSelected(option)"
      >
        <ws-checkbox *ngIf="multiSelect; else textOnly" [checked]="isSelected(option)" (click)="$event.preventDefault(); selectOption(option, $event)">
          <span right>
            <ng-container *ngIf="optionTemplate; else defaultOptionLabel">
              <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: option }"></ng-container>
            </ng-container>
            <ng-template #defaultOptionLabel>{{ formatter(option) }}</ng-template>
          </span>
        </ws-checkbox>

        <ng-template #textOnly>
          <ng-container *ngIf="optionTemplate; else defaultOptionText">
            <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: option }"></ng-container>
          </ng-container>
          <ng-template #defaultOptionText>{{ formatter(option) }}</ng-template>
        </ng-template>
      </button>
    </ng-container>
    <ng-template #noOptions>
      <span class="no-options-message">
        {{ "None" | translate }}
      </span>
    </ng-template>
  </ng-container>

</mat-menu>
